// extracted by mini-css-extract-plugin
export default {"LoaderFlowyContainer":"LoaderFlowy_LoaderFlowyContainer__xq6vR"};